.top {
    padding-bottom: 24px;
    margin-bottom: 24px;
    border-bottom: 1px #ebe8e8 solid;
}
